import { Tabs } from "antd";
import type { DataTableTab } from "~components/DataTable/types/dataTableTab.ts";

type Props<T> = {
  tabs: DataTableTab<T>[];
  activeKey?: string;
  onChange: (activeKey: string) => void;
};

export const DataTableTabs = <T,>({ tabs, activeKey, onChange }: Props<T>) => (
  <Tabs className="data-table-tabs" activeKey={activeKey} onChange={onChange} items={tabs.map(({ key, label }) => ({ key, label }))} />
);
